/*
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 09:26:28
 * @LastEditors: whaoo
 * @LastEditTime: 2023-11-09 10:29:26
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
import { Input, Message } from 'element-ui';
import { Dialog } from 'element-ui';
import { Table } from 'element-ui';
import { TableColumn } from 'element-ui';
import { Button } from 'element-ui';
import { Pagination } from 'element-ui';
import { MessageBox } from 'element-ui';
import { Select } from 'element-ui'
import { Option } from 'element-ui'
import { Form } from 'element-ui'
import { FormItem } from 'element-ui'
import { Switch } from 'element-ui'
import { Row,Col } from 'element-ui'

import date from '../static/date'
Vue.prototype.$dateFtt=date
Vue.use(Row)
Vue.use(Col)
Vue.use(Switch)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Button)
Vue.use(Pagination)
Vue.use(Input)
Vue.prototype.$message=Message
Vue.prototype.$confirm=MessageBox.confirm
Vue.prototype.$alert=MessageBox.alert
import { Loading } from 'element-ui';

Vue.use(Loading.directive);
import HighchartsVue from 'highcharts-vue'
Vue.use(HighchartsVue)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js